import styled from "styled-components";
import bg1 from "./assets/Graphics/bg1.png";
import bg2 from "./assets/Graphics/bg2.png";

export const SingleCard = styled.div`
  display: flex;
  /* margin: 1em 0; */
  padding: 3em 0;
  /* border-bottom: 1px dashed #6b6b6b; */
  border-top: 2px solid #a3a3a3;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const BusinessSec = styled.section`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  /* padding: 1em; */
  /* background-color: green; */
  /* background-color: red; */

  @media (max-width: 768px) {
    border: none;
    padding: 0 25px;
  }
`;

export const Title = styled.div`
  text-align: center;
  h2 {
    font-size: clamp(28px, 3vw, 5em);
    text-transform: capitalize;
  }
  span {
    font-size: clamp(14px, 1.5vw, 3em);
  }
`;

export const TechSec = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* justify-content: space-evenly; */
  /* padding-left: 2em; */
  /* background-color: #eee; */
  /* border-radius: 60% 50% 80% 30%; */
  /* max-height: 300px; */

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const Info = styled.div`
  /* background-color: red; */
  display: flex;
  flex-direction: row;
  /* padding: 1em 10px; */
  width: 100%;
  img {
    background-color: #eee;
    flex: 0 1 auto;
    max-width: 30%;
    height: auto;
    align-self: center;
    object-fit: cover;
    border-radius: 50% 80% 60% 90%;
  }

  @media (max-width: 922px) {
    flex-direction: column;
    img {
      max-width: 45%;
      margin: 0 auto;
    }
  }

  @media (max-width: 768px) {
    flex-direction: row;
    padding: 5px 0;
    img {
      max-width: 30%;
      margin: 0 auto;
    }
  }

  @media (max-width: 576px) {
    flex-direction: column;
    padding: 5px 0;
    img {
      max-width: 55%;
    }
  }
`;

export const ItemSec = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* justify-content: space-evenly; */
  flex: 1 1 auto;
  padding-left: 2em;
  
  .title {
    // background-color: yellow;
    padding: 5px;
    width: 100%;
    text-align: center;
    background-image: url(${bg1});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    
    font-weight: 900;
    text-transform: capitalize;
    font-size: clamp(18px, 1.1vw, 3em);
  }

  ul {
    // background-color: aqua;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 5px;
  }
  li {
    display: flex;
    align-items: center;

    font-weight: 900;

    svg {
      padding-top: 1px;
      min-width: 15px;
      max-width: 15px;
    }
    span {
      padding: 0 8px;
    }
  }

  &.mission {
    background-color: #eee;
    padding: 0 20px;
    /* flex: 1 0 auto; */
    border-radius: 60% 50% 80% 30%;
    max-height: 300px;
    /* max-width: 80%; */

    ul {
      background-position: 0 10px;
      line-height: 1.71;
      border-radius: 0 500px 500px 0;
      padding-top: 10px;
      background-image: linear-gradient(#c9c5c5 1px, transparent 1px);
      background-size: 100% 1.5rem;
      font-size: clamp(14px, 1vw, 3em);
      /* background-color: red; */
    }
  }

  &.vision {
    .title {
      background-position: ${(props) => props.lang === "en" ? "left" : "right"};
      text-align: ${(props) => props.lang === "en" ? "left" : "right"};
      padding: 2px;
      padding-left: ${(props) => props.lang === "en" ? "25px" : "2px"};
      padding-right: ${(props) => props.lang === "fa" ? "40px" : "2px"};
      font-size: clamp(18px, 1.1vw, 3em);
      font-weight: 900;
    }

    ul {
      font-size: clamp(15px, 1.1vw, 5em);
    }
  }

  @media (max-width: 768px) {
    align-items: start;
    width: 100%;
    padding-left: 0em;
    .title {
      padding: 20px 40px;
      align-self: center;
    }

    &.mission {
      border-radius: 10em 80% 120px 80px;
      .title {
        font-size: clamp(18px, 1.1vw, 3em);
        font-weight: 900;
        max-width: 50%;
        /* width: 50%; */
        padding: 10px;
      }
      ul {
        margin-bottom: 10px;
      }
    }
  }
`;
